import { Helmet } from 'react-helmet-async';
import { useContext } from 'react';
import { TranslationsContext } from '../../../context/TranslationsContext';

export const PrivacyPolicyHelmet = () => {
  const { fullTranslations, mainLang } = useContext(TranslationsContext);

  return (
    <Helmet htmlAttributes={{ lang: mainLang, amp: undefined }}>
      <title>{fullTranslations?.head?.privacyPolicy?.title}</title>
      <meta
        name="description"
        content={fullTranslations?.head?.privacyPolicy?.description}
      />
      <meta property="og:image" content="https://www.mykin.in/preview.png" />
      <meta property="og:image:width" content="663" />
      <meta property="og:image:height" content="649" />
      <meta
        property="og:title"
        content={fullTranslations?.head?.privacyPolicy?.title}
      />
      <meta
        property="og:description"
        content={fullTranslations?.head?.privacyPolicy?.ogDescription}
      />
      <meta property="og:url" content="https://www.mykin.in/pp" />
      <meta name="twitter:image" content="https://www.mykin.in/preview.png" />
      <meta
        name="twitter:title"
        content={fullTranslations?.head?.privacyPolicy?.title}
      />
      <meta
        name="twitter:description"
        content={fullTranslations?.head?.privacyPolicy?.ogDescription}
      />
      <meta property="vk:url" content="https://www.mykin.in/pp" />

      <meta property="vk:image" content="https://www.mykin.in/preview.png" />
      <meta
        property="vk:title"
        content={fullTranslations?.head?.privacyPolicy?.title}
      />
      <meta
        property="vk:description"
        content={fullTranslations?.head?.privacyPolicy?.ogDescription}
      />
    </Helmet>
  );
};
